"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SpinnerMixin = require("../../mixins/components/SpinnerMixin");
var StyledSpinner = /*#__PURE__*/_styledComponents.default.svg.withConfig({
  displayName: "StyledSpinner",
  componentId: "c11n-8-107-0__sc-1qy1aqr-0"
})(["", ""], _SpinnerMixin.SpinnerMixin);
exports.StyledSpinner = StyledSpinner;